module.exports = __webpack_public_path__ + "media/images/front/icon_pen-065d40e1e968fd93f9b681fd0318b59c.png";